import React, {Fragment, useContext, useEffect, useState} from "react";
import {Form, FormGroup} from "reactstrap";
import {useForm} from "react-hook-form";
import {Btn} from "../../../../../AbstractElements";
import Loader from "../../../../../Layout/Loader";
import axiosConfig from "../../../../../Config/axios";
import {getApplicationRoute} from "../../../../../Route/RouteIndex";
import AuthorizationContext from "../../../../../_helper/Authorization";
import type {Board} from "../../Types/BoardTypes";
import type {AuthorizationContextType} from "../../../../../_helper/Authorization/AuthorizationTypes";
import TextInput from "../../../../../CommonElements/Input/TextInput";

interface BoardUpdateFormValues {
    name: string;
    number_of_slots: number;
}

interface BoardUpdateFormProps {
    board: Board;
    callBack?: (board: Board) => void;
}

const UpdateBoardForm: React.FC<BoardUpdateFormProps> = ({board, callBack}) => {
    const [loaderVisibility, setLoaderVisibility] = useState<boolean>(false);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    const {
        register,
        handleSubmit,
        clearErrors,
        formState: {errors},
        setValue
    } = useForm<BoardUpdateFormValues>();

    useEffect(() => {
        if (!board) return;
        setValue("name", board.name || "");
        setValue("number_of_slots", board.number_of_slots || 0);
    }, [board, setValue]);

    const onSubmit = (data: BoardUpdateFormValues) => {
        clearErrors();
        setLoaderVisibility(true);
        axiosConfig
            .put(`${getApplicationRoute("board")}/${board.id}`, data)
            .then((response: { data: { data: Board; }; }) => {
                if (response?.data?.data) {
                    callBack?.(response.data.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    };
    return (
        <Fragment>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Loader visibility={loaderVisibility}/>
                <TextInput name={'name'} type={'text'} label={'Board Name'} register={register}
                           errors={errors} placeholder={'Board Name'} options={{required: true}}/>
                <TextInput name={'number_of_slots'} type={'number'} label={'Number of Slots'} register={register}
                           errors={errors} placeholder={'Enter number of slots'} options={{required: true}}/>
                <FormGroup>
                    <Btn attrBtn={{
                        className: "d-block w-100 mt-4",
                        color: "primary",
                        type: "submit"
                    }}>
                        Update
                    </Btn>
                </FormGroup>
            </Form>
        </Fragment>
    );
};

export default UpdateBoardForm;

